import morphism, { StrictSchema } from 'morphism'
import { MiddlewareAPI, Dispatch, Action } from 'redux'

import ClientFlightInterface from '../../interfaces/client/Flight'
import ServerFlightTravelClassSeatCountsInterface from '../../interfaces/server/FlightTravelClassSeatCounts'
import ClientFlightWithTravelClassSeatCountsInterface from '../../interfaces/server/FlightWithTravelClassSeatCounts'

import flightSchema from '../../schemas/client/flight'

import { REQUEST_FLIGHT } from '../../actions/flights/requestFlight'
import receiveFlight from '../../actions/flights/receiveFlight'

import requestFlightInfo from '../../utils/flights/requestFlightInfo'
import requestFlightAllotment from '../../utils/flights/requestFlightAllotment'

export interface FlightsAction extends Action {
  flightId: string
}

export default (store: MiddlewareAPI) => (next: Dispatch) => async (
  action: FlightsAction
) => {
  next(action)

  if (action.type !== REQUEST_FLIGHT) return

  const dispatch = store.dispatch

  const flightInformation = await requestFlightInfo(action.flightId)
  const allotment = await requestFlightAllotment(action.flightId)

  // @improvement send action that request failed
  if (flightInformation.errors && flightInformation.errors.length) return
  if (!Array.isArray(allotment)) return

  const flightTravelClassSeatCounts: ServerFlightTravelClassSeatCountsInterface = allotment.find(
    (flightTravelClassSeatCount: ServerFlightTravelClassSeatCountsInterface) =>
      flightTravelClassSeatCount.flightId === action.flightId
  ) || { flightId: action.flightId, travelClassSeatCounts: [] }
  const flight: ClientFlightWithTravelClassSeatCountsInterface = {
    ...flightInformation,
    travelClassSeatCounts: flightTravelClassSeatCounts.travelClassSeatCounts,
  }

  const formattedFlight: any = morphism<
    StrictSchema<
      ClientFlightInterface,
      ClientFlightWithTravelClassSeatCountsInterface
    >
  >(flightSchema, flight)

  dispatch(receiveFlight(formattedFlight))
}
